<template>
  <div>
    <el-table ref="tableData" :data="tableList" size="small" stripe>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="id" width="80" :label="$t('id')" />
      <el-table-column prop="cashier" :label="$t('data-abertura')" />
      <el-table-column prop="userName" :label="$t('caixa')" />
      <el-table-column prop="type" :label="$t('tipo')" />
      <el-table-column prop="value" :label="$t('valor')">
        <template slot-scope="scope">
          {{
            scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}
        </template>
      </el-table-column>
      <el-table-column width="270" align="right">
        <template slot="header">
          <el-button type="text" icon="el-icon-check" @click="approveAll()">Aprovar</el-button>
          <el-button type="text" icon="el-icon-close" @click="reproveAll()">Reprovar</el-button>
        </template>
        <template slot-scope="scope">
          <el-button type="success" plain size="small" title="Aprovar" icon="el-icon-check"
            @click="approve(scope.row.id, scope.row.userName)">Aprovar</el-button>
          <el-button type="danger" title="Reprovar" size="small" icon="el-icon-close"
            @click="reprove(scope.row.id, scope.row.userName)">Reprovar</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
import { i18n } from "@/plugin/i18n";
export default {
  data() {
    return {
      tableList: [],
    }
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
  methods: {
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.myauthorization()
        .then((response) => {
          vm.tableList = response.data;
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => loading.close());
    },
    approve(id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-aprovacao-caixa", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.action('approved', [id], "Autorização realizada com sucesso!");
      });
    },
    reprove(id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-reprovacao-caixa", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.action('recused', [id], "Autorização reprovada com sucesso!");
      });
    },
    action(type, list, message) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.approveReprove(type, list)
        .then((response) => {
          vm.fetch();
          this.$message({
            type: "success",
            duration: 5000,
            message: message,
          });
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => loading.close());
    },
    approveAll() {
      const vm = this;
      const data = vm.$refs.tableData.selection.map(x => x.id);
      if (data.length === 0) {
        return this.$message({
          type: "error",
          message: "Selecione as autorizações para aprovação",
          duration: 5000,
        });
      }
      this.$confirm(
        i18n.t("confirmar-aprovacao-caixa", { id: vm.$refs.tableData.selection.map(x => x.userName) }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.action('approved', data, "Autorizações aprovadas com sucesso!");
      });
    },
    reproveAll() {
      const vm = this;
      const data = vm.$refs.tableData.selection.map(x => x.id);
      if (data.length === 0) {
        return this.$message({
          type: "error",
          message: "Selecione as autorizações para reprovação",
          duration: 5000,
        });
      }
      this.$confirm(
        i18n.t("confirmar-reprovacao-caixa", { id: vm.$refs.tableData.selection.map(x => x.userName) }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.action('recused', data, "Autorizações reprovadas com sucesso!");
      });
    },
  }
}
</script>